import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService {

  readonly loadingState = signal<boolean>(false);
  readonly isLoading = toObservable(this.loadingState);

  show() {
    this.loadingState.set(true);
  }
  hide() {
    this.loadingState.set(false);
  }
}